import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const industries = [
    { n: "01", name: "Healthcare" },
    { n: "02", name: "Banking" },
    { n: "03", name: "Finance" },
    { n: "04", name: "Entertainment" },
    { n: "05", name: "E-commerce" },
];

export default function Expertise() {
    return (
        <section className="bg-lav-100 py-24 lg:py-32" data-testid="expertise-section">
            <div className="mx-auto max-w-5xl px-4 sm:px-8 lg:px-16">
                <Reveal>
                    <Eyebrow>Experience</Eyebrow>
                    <h2 className="mt-4 max-w-xl text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                        Five industries, one obsession — the person on the other side of the screen.
                    </h2>
                </Reveal>

                <div className="mt-14">
                    {industries.map((ind, i) => (
                        <Reveal key={ind.n} delay={i * 0.06}>
                            <div
                                className="group flex cursor-default items-center gap-6 border-b border-viol-light/60 py-6 transition-all duration-300 first:border-t hover:bg-white/60 hover:pl-4 sm:gap-10"
                                data-testid={`industry-${ind.name.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                <span className="font-mono text-xs font-medium text-viol/60 transition-colors group-hover:text-viol">
                                    {ind.n}
                                </span>
                                <span className="flex-1 text-2xl font-extrabold tracking-tight text-ink transition-colors duration-300 group-hover:text-viol sm:text-4xl">
                                    {ind.name}
                                </span>
                                <ArrowUpRight className="h-5 w-5 text-ink/20 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-sun-deep" />
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.15}>
                    <p className="hand mt-8 rotate-[-1.5deg] text-center text-2xl text-viol" aria-hidden="true">
                        different domains, same care for craft ✦
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
